import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import { getProductNameTextFromApiName } from 'ui-addon-upgrades/_core/common/adapters/getProductNameText';
import { getUpgradeButtonTextFromApiName } from 'ui-addon-upgrades/_core/common/adapters/getUpgradeButtonText';
import { getCorrectedUpgradeData } from 'ui-addon-upgrades/_core/utils/getCorrectedUpgradeData';
import UIPricingPageRedirectButton from '../../button/UIPricingPageRedirectButton'; // @ts-expect-error dependency missing types

import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { SUITE_STARTER } from 'self-service-api/constants/UpgradeProducts';
import { getApp, getBannerI18nTitleKey, getScreen, getSource } from '../utils';
import DefaultBanner from './DefaultBanner';

const RemoveBrandingBanner = ({
  upgradePoint,
  className,
  style,
  canViewNewSeats,
  'data-test-id': dataTestId = 'locked-feature-banner',
  isFreePortal = false
}) => {
  const app = getApp();
  const screen = getScreen();
  const source = getSource(app, screen, upgradePoint.upgradeKey);
  const upgradeData = {
    app,
    screen,
    source,
    upgradeProduct: upgradePoint.upgradeProduct,
    upgradeProducts: upgradePoint.upgradeProducts,
    apiName: upgradePoint.apiName,
    apiNames: upgradePoint.apiNames,
    uniqueId: upgradePoint.upgradeKey,
    primaryColor: upgradePoint.primaryColor,
    team: upgradePoint.team,
    status: upgradePoint.status
  };
  const correctedUpgradeData = Object.assign({
    feature: upgradePoint.feature,
    pointType: upgradePoint.pointType,
    upgradeKey: upgradePoint.upgradeKey
  }, getCorrectedUpgradeData(upgradeData));
  const apiNameToUse = canViewNewSeats && upgradeData.apiName || UpgradeProductToApiNameMap[correctedUpgradeData.upgradeProduct];

  const titleText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nTitleKey('upgrades.removeBrandingBanner.titles', upgradePoint.featureTranslationKey)
  });

  const bannerSubtext = /*#__PURE__*/_jsxs(UIBox, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.lockedFeatureBanner.text"
    }), "\xA0", /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.message.productName",
      options: {
        productName: getProductNameTextFromApiName(apiNameToUse)
      }
    })]
  });

  const getUpgradeButton = () => {
    return /*#__PURE__*/_jsx(UIPricingPageRedirectButton, {
      upgradeData: correctedUpgradeData,
      use: "tertiary-light",
      isUpgradePoint: true,
      goToSuiteStaterInterstitial: isFreePortal && (correctedUpgradeData.apiName === CRM_SUITE_STARTER_BUNDLE || correctedUpgradeData.upgradeProduct === SUITE_STARTER),
      children: getUpgradeButtonTextFromApiName('default', apiNameToUse)
    });
  };

  return /*#__PURE__*/_jsx(DefaultBanner, {
    titleText: titleText,
    className: className,
    dataTestId: dataTestId,
    subtext: bannerSubtext,
    button: getUpgradeButton(),
    style: style
  });
};

export default RemoveBrandingBanner;